import { TokenRepository } from "../domain/tokenRepository";

export function copyToken(
  tokenRepository: TokenRepository,
  token: string
): void {
  return tokenRepository.copy(token);
}
